module.exports = __webpack_public_path__ + "static/media/Accenture.f4b04260.png";